<template>
  <div class="login-footer">
    <div
      class="carousel"
      data-cy="login-company-partners-carousel"
    >
      <swiper
        class="content"
        :options="swiperOptions"
      >
        <swiper-slide
          v-for="(partner, index) in partners"
          v-if="partner.logo"
          :key="index"
        >
          <c-image
            class="login-footer-logo"
            :alt="partner.name"
            :src="partner.logo"
            is-background
          />
        </swiper-slide>

        <div
          class="swiper-button -prev"
          slot="button-prev"
        >
          <k-icon
            class="icon"
            icon="left1"
            size="22"
          />
        </div>

        <div
          class="swiper-button -next"
          slot="button-next"
        >
          <k-icon
            class="icon"
            icon="arrow-right"
            size="22"
          />
        </div>
      </swiper>
    </div>
    <div
      class="developed"
      v-if="!hideDeveloped"
      data-cy="login-developedby-description"
    >
      <p class="text">
        Desenvolvido por
      </p>
      <c-clube-logo
        is-grey
        class="logo"
      />
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { KIcon } from 'kaledo-components'

export default {
  components: {
    swiper,
    swiperSlide,
    CClubeLogo: () => import('@/components/CComponents/CClubeLogo'),
    KIcon
  },
  props: {
    partners: {
      type: Array,
      required: true
    },
    hideDeveloped: Boolean
  },
  data () {
    return {
      swiperOptions: {
        slidesPerView: 'auto',
        spaceBetween: 10,
        autoplay: true,
        navigation: {
          nextEl: '.swiper-button.-next',
          prevEl: '.swiper-button.-prev',
          disabledClass: '-disabled',
          hiddenClass: '-hidden'
        }
      },
      placeholder: () => require('@/assets/img/campaign-placeholder.svg')
    }
  }
}
</script>

<style lang="scss">
@import '~@style/reference';

.login-footer {
  display: flex;
  justify-content: center;
  height: 100%;

  & .login-footer-logo {
    width: 130px;
    height: 56px;
    padding: 28px 65px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

  & > .carousel {
    padding-left: 100px;
    max-width: calc(100% - 420px);
    margin-right: auto;
    display: flex;
    align-items: center;

    & > .swiper-container-horizontal {
      padding: 0 15px;
    }

    & > .content {
      display: flex;
      position: relative;
      overflow: hidden;
      max-width: 550px;

      & > .swiper-wrapper { display: flex; }

      .swiper-slide {
        display: flex;
        justify-content: center;
        align-items: center;
        max-height: 150px;
        padding: 0 18px;
      }

      & > .swiper-button {
        z-index: 5;
        background-color: $white-color;
        display: block;
        position: absolute;
        cursor: pointer;
        top: 50%;
        border-radius: 50%;
        width: 60px;
        height: 60px;
        transition: opacity .3s ease;

        & > .c-icon.icon {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }

        &.-disabled,
        &.-hidden { opacity: 0; }

        &.-prev {
          transform: translate(-50%, -50%);
          justify-content: center;
          display: flex;
          align-items: center;

          & > .c-icon.icon { right: 8px; }
        }

        &.-next {
          right: 5px;
          transform: translate(50%, -50%);
          justify-content: center;
          display: flex;
          align-items: center;

          & > .c-icon.icon { left: 8px; }
        }

        &.-partner {
          background-color: rgba(white, .5);

          & > .icon { fill: $title-color; }
        }
      }
    }
  }

  & > .developed {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 30px;
    margin-left: auto;

    & > .text { margin-right: 10px; }
    & > .logo { height: 55px; }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login/FooterComponent.vue